import React from "react";

import { Span } from "Common/HTML";
import type { CarrierLogoProps } from "Theme/CarrierLogo";

import type { Plan } from "Utils/types";

// Logos sizes need to be divisible by 8px
const LOGO_SIZES = {
  5: 96,
  4: 48,
  // TODO: get minimum sizes on logos.  This size is too big for some logos, need to get better quality logos
  3: 32,
  2: 24,
  1: 16,
};

const maxSizePx = (maxSize) => LOGO_SIZES[maxSize.toString()];

// The logo's maxSize is both the target size and the maximum height of the logo
// The logo is also bound by width size (i.e. will not get larger than the containing elements)
export const CarrierLogo = (props: CarrierLogoProps) => {
  const { plan, maxSize, className, ...rest } = props;
  const maxHeight = (maxSize && maxSizePx(maxSize)) || "auto";
  // max height is needed in the wrapping div along with the image itself because
  // it prevents the logo from being stretched, example: maxHeight is set to 48 but
  // the logo is only 38 high, it won't be stretched up to 48
  return (
    <Span
      className={className}
      {...rest}
      style={{
        display: "inline-block",
        maxHeight,
      }}
    >
      <img
        src={plan.carrier_logo}
        title={plan.carrier}
        alt={plan.carrier}
        className="img-responsive"
        style={{
          maxHeight,
        }}
      />
    </Span>
  );
};
type CarrierLogoFlexboxProps = {
  plan: Plan;
  maxSize?: string | number;
  alignItems?: string;
  imageProps?: CarrierLogoProps;
};
// Flexbox used here because:
// Some logos are located inside a Flexbox already while others are not.
// Easily position the Logo how you want, like vertical alignment to center.
export const CarrierLogoFlexbox = (props: CarrierLogoFlexboxProps) => {
  const { plan, maxSize, alignItems = "center", imageProps = {}, ...rest } = props;
  return (
    <Span
      style={{
        display: "flex",
        alignItems,
        height: "100%",
      }}
      {...rest}
    >
      <CarrierLogo plan={plan} maxSize={maxSize} {...imageProps} />
    </Span>
  );
};
export default CarrierLogo;
